import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import {
  selectionOptionsSchema,
  vocabularyProfileShape,
  withParallelPredictions,
  wordIdsSchema,
} from "@bindery/shared/corpus/selection";
import * as z from "zod";
import { ORIENTATION_API_PREFIX } from "./errors";

export const READING_SELECTION_PATH = `${ORIENTATION_API_PREFIX}/reading-selection`;

// The "-1" of the +1/-1/0 encoding (#168), as word ids: a word the child
// missed, skipped or hesitated on. `selectReadings` scores only known words,
// so unknown ids exist to cancel a prediction, never to be scored.
export const readingSelectionRequestSchema = withParallelPredictions(
  z.strictObject({
    sessionId: z.string().regex(UUID_REGEX),
    ...vocabularyProfileShape,
    unknownWordIds: wordIdsSchema.default([]),
    options: selectionOptionsSchema.prefault({}),
  }),
);
export type ReadingSelectionRequest = z.input<
  typeof readingSelectionRequestSchema
>;

export const readingCandidateSchema = z.object({
  id: z.string(),
  title: z.string().nullable(),
  totalWordCount: z.number(),
  knownWordCount: z.number(),
  unknownWordCount: z.number(),
  knownPercent: z.number(),
  challengeScore: z.number(),
  source: z.string().nullable(),
  publication: z
    .object({
      id: z.string(),
      title: z.string(),
      coverImage: z.string().nullable(),
      author: z.string().nullable(),
    })
    .nullable(),
});

export const readingSelectionResponseSchema = z.object({
  candidates: z.array(readingCandidateSchema),
});
export type ReadingSelectionResponse = z.infer<
  typeof readingSelectionResponseSchema
>;
